import { Environment } from '@core/models/environment.model';
import { provideKeycloak } from 'keycloak-angular';

declare global {
  interface Window {
    signOut: any;
    keycloak: any;
    config: any;
  }
}

export const provideKeycloakAngular = (env: Environment) =>
  provideKeycloak({
    config: {
      url: env.keycloak.issuer,
      realm: env.keycloak.realm,
      clientId: env.keycloak.clientId
    },
    initOptions: {
      enableLogging: true,
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      checkLoginIframe: false
    }
  });
